import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { height, padding, width } from '@mui/system';

export const useStyles = makeStyles((theme: Theme) => ({
  navBar: {
    width: '100%',
    background: 'transparent',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 999,
    display: 'flex',
    justifyContent: 'center',
  },
  navLinks: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },

  navLink: {
    color: '#C9C9C9',
    fontFamily: 'Figtree',
    fontSize: '1.55vh',
    fontWeight: 400,
    lineHeight: '136%',
    letterSpacing: '0.28px',
    cursor: 'pointer',
  },
  appbar: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1.5vh 3vh',
    zIndex: 999,
    // margin: '0 auto',
    top: 0,
    transition: 'background 0.3s ease, backdrop-filter 0.3s ease',
  },
  appbarScrolled: {
    background: 'rgba(0, 4, 25, 0.71)',
    backdropFilter: 'blur(19.25px)',
    borderRadius: '1.2vh',
    display: 'flex',
    width: '80%',
    maxWidth: '158.6vw',
    padding: '1vh 2.4vh',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '1.2vh auto',
    transition: 'background 0.3s ease, backdrop-filter 0.3s ease',
    boxSizing: 'border-box',
    [theme.breakpoints.down('lg')]: {
      width: '90%',
    },
  },
  toolBar: {
    width: '100%',
    background: 'transparent',
    padding: '1vh !important',
    display: 'flex',
    justifyContent: 'space-between!important',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      width: '90%',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  toolBarScrolled: {
    width: '100% !important',
    padding: '0 !important',
  },
  LogoContainer: {
    height: '5vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '@media (max-width : 786px )': {
      height: 'auto',
      width: 'auto',
    },
  },
  Logo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      height: '150%',
    },
  },
  ApplyNowBtn: {
    display: 'flex',
    background: 'linear-gradient(180deg, rgba(55, 38, 18, 0.00) -175%, rgba(255, 133, 11, 0.50) 140%), #B73601',
    backgroundColor: 'rgba(183, 54, 1, 1) !important',
    padding: '0.8vh 2vh !important',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.8vh',
    fontSize: '1.4vh !important',
    borderRadius: '1.2vh !important',
    border: '1px solid #FFF',
    boxShadow: '0px 1px 2px 0px #FA854D, 0px 0px 0px 3px rgba(255, 181, 114, 0.16)',
    color: 'rgba(255, 255, 255, 1) !important',
    [theme.breakpoints.down('lg')]: {
      padding: '0.8vh 1.2vh !important',
      fontSize: '1.2vh !important',
      borderRadius: '1.4vh !important',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none !important',
    },
  },
  SubmitNowBtn: {
    display: 'flex',
    // background: 'linear-gradient(180deg, rgba(55, 38, 18, 0.00) -175%, rgba(255, 133, 11, 0.50) 140%), #B73601',
    backgroundColor: 'transparent !important',
    padding: '0.8vh 2vh !important',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.8vh',
    fontSize: '1.4vh !important',
    borderRadius: '1.2vh !important',
    border: '1px solid #FFF',
    boxShadow: '0px 1px 2px 0px #FA854D, 0px 0px 0px 3px rgba(255, 181, 114, 0.16)',
    color: '#E14809 !important',
    [theme.breakpoints.down('lg')]: {
      padding: '0.8vh 1.2vh !important',
      fontSize: '1.2vh !important',
      borderRadius: '1.4vh !important',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none !important',
    },
  },
}));
